import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class WrongFirstAdvanceDocumentVersionError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.first-advance-document.wrong-version');
    }
}
